var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEyesClose = function SvgEyesClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1001 14.5249C10.4251 14.6999 9.72508 14.7832 9.00008 14.7832C6.27508 14.7832 3.83341 13.5082 2.16675 11.4916C1.00008 10.0832 1.00008 7.90824 2.16675 6.50824C2.30008 6.34157 2.45008 6.18324 2.60008 6.0249",
    stroke: "#5768FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 11.4917C15.1667 12.2917 14.375 12.975 13.5 13.5083L4.4917 4.49167C5.8167 3.67501 7.35003 3.21667 9.00003 3.21667C11.725 3.21667 14.1667 4.49168 15.8334 6.50835C17 7.90835 17 10.0917 15.8334 11.4917Z",
    stroke: "#5768FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5667 9.00002C11.5667 9.70835 11.275 10.35 10.8167 10.8167L7.18335 7.18335C7.64168 6.71668 8.29168 6.43335 9.00002 6.43335C10.425 6.43335 11.5667 7.57502 11.5667 9.00002Z",
    stroke: "#5768FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29175 1.29163L4.49175 4.49162L7.18341 7.18329L10.8167 10.8166L13.5084 13.5083L16.7084 16.7083",
    stroke: "#5768FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyesClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eyes-close.90d467ce.svg";
export { ForwardRef as ReactComponent };